import React from "react";

import { Container, CircleBox, Title } from './styles';

interface StatusProps {
  type: string;
  mode?: string;
}

const statusText = {
  'true': 'Ativo',
  'false': 'Inativo'
}

const statusTextYesOrNo = {
  'true': 'Sim',
  'false': 'Não'
}

const Status = ({ type, mode = 'activeInactive' }: StatusProps) => {
  // Determines which set of texts to use based on mode
  const text = mode === 'yesNo' ? statusTextYesOrNo[type] : statusText[type];

  return (
    <Container>
      <CircleBox type={type} />
      <Title type={type}>{text}</Title>
    </Container>
  );
}

export default Status;